export default {
    data () {
        return {
            userPrintedHisCouponWithSuccess: false,
        }
    },
    methods: {


        userAskedToPrintCouponsNow(){
            this.log("userAskedToPrintCouponsNow()", 'function');
            this.currentPage = "printcoupon";
        },

        userAskedToPrintCouponsLater(){
            // * As Page 0 is never used, this is a bit obsolete (but working, probably). 
            this.log("userAskedToPrintCouponsLater()", 'function');
            /*
            POST – api/v1/coupons /send-email/print-link – “idparticipation” en paramètre =>
            Envoie un mail AFTERSURVEY lié au refhd de l’action avec un lien vers la page 1
            */
            let data = {
                "idparticipation": this.participationKeyFromUrl,
                "idParticipationType": this.getIdOfRepartCode('HCDCPRINT'),
            };
            this.postToAxios(this.callConfigs.postTriggerMailSendForUser, data);
        },

        userAskedToPrintCoupons(){
            this.log("userAskedToPrintCoupons()", 'wip');
            this.userPrintedHisCouponWithSuccess = true;
            
            this.pendingParticipationSent = true;
            this.$store.dispatch('setSpinner', true);

            /* WIP - à bien tester
            POST – api/v1/coupons/print – “idparticipation” en paramètre =>
            confirme que le conso veut imprimer sont coupon, renverra directement le contenu du PDF
            (donc il ne faut pas chercher le dossier sur un serveur)
            */

            let data = {
                "idparticipation": this.participationKeyFromUrl,
                "idParticipationType": this.getIdOfRepartCode('HCDCPRINT'),
            };
            
            this.postToAxios(this.callConfigs.postPrintCouponAndGetPdf, data);
        },

        mailAfterSurveyWasSent(){
            this.log("Mail was triggered", 'green');
            this.goto('confirmationMail');
        },
        mailAfterSurveyWasNotSent(error){
            this.log("Mail was not triggered", 'red');
            this.log(error);
            this.iGotThisErrorFromActionApi(error, this.$t('errors.mailWithCouponsNotSent'));
        },

        decodeBase64(embasedData){
            // Function receive data encoded in base 64
            let decodedData = atob(embasedData);
            /* This way */
            var uint8Array = new Uint8Array(decodedData.length);
            for (var i = 0; i < decodedData.length; i++) {
                uint8Array[i] = decodedData.charCodeAt(i);
            }
            /* Or this way */
            // Alternatively, create Uint8Array directly from base64-decoded data
            // const uint8Array = new Uint8Array(decodedData.split('').map(char => char.charCodeAt(0)));
            return uint8Array;
        },

        cleanPreviousIframe(){
            // Remove previous iframe to avoid confusion and have a clean DOM
            let previousIframe = document.querySelector('#print_pdf');
            if(previousIframe){ 
                previousIframe.remove();
            }
        },



        async printPdf(pdfData){
            let pdf = this.decodeBase64(pdfData);
            let pdfFile = new Blob([pdf], {type: "application/pdf"});
            let pdfUrl = URL.createObjectURL(pdfFile);

            /* * We don't make the distinction anymore : all mobile download, all desktop print */
            const safariDetected = this.isSafariIOS(); // Safari, but Brave too
            const iphoneDetected = this.isIphone();
            this.log(`Safari detected: ${safariDetected} | iphoneDetected: ${iphoneDetected}`);
            /* * …but interesting to keep under the hand nevertheless */

            this.cleanPreviousIframe();

            // Print-capable Devices (all desktop)
            // Safari on iphone can print, but Brave can't, and we can't distinguish the two.
            if(!this.isUserOnPortableDevice){
                this.log("User isn't considered on mobile", 'low');
                this.createPrintPdfIframe(pdfFile, pdfUrl); 
            }

            // Print-uncapable Devices
            // We choose to not print from any mobile device
            if(this.isUserOnPortableDevice ){
                this.log("User is considered on mobile", 'low');
                try {
                    let success = await this.downloadCouponPdf(pdfFile, pdfUrl);
                    this.log("Success: " + success, 'low');
                    // In any case, success or not, we go to confirmation page.
                    this.pendingParticipationSent = false;
                    this.currentPage = 'confirmationCoupon';
                }catch(error){
                    console.error(error);
                }
                this.$store.dispatch('setSpinner', false);
            }
        },

        isIphone(){
            const ua = navigator.userAgent;
            return /iPhone/.test(ua);
        },

        isSafariIOS(){
            const ua = navigator.userAgent;
            // iPhone, iPad, iPod
            const isIOS = /iP(hone|ad|od)/.test(ua);
            // Moteur WebKit mandatory for Safari
            const isWebkit = /WebKit/.test(ua);
            // Explicit exclusion of other browsers iOS (also using WebKit)
            const isNotChrome = !/CriOS/.test(ua);     // Chrome
            const isNotFirefox = !/FxiOS/.test(ua);    // Firefox
            const isNotEdge = !/EdgiOS/.test(ua);      // Edge
            const isNotOpera = !/OPiOS/.test(ua);      // Opera
            const isNotDuckDuckGo = !/DuckDuckGo/.test(ua); // DuckDuckGo Browser

            return isIOS && isWebkit && isNotChrome && isNotFirefox && isNotEdge && isNotOpera && isNotDuckDuckGo;
        },



        async downloadCouponPdf(blob, pdfUrl) {
            const filename = 'coupon.pdf';

            // Test if we are on Chromium on IOS
            const isChromeOnIOS = /CriOS/i.test(navigator.userAgent) && /iPad|iPhone|iPod/.test(window.navigator.userAgent);

            // ✅ Check if the File System Access API is available (Chromium+HTTPS) and not iOS
            const supportsPicker = 
            'showSaveFilePicker' in window &&
            (() => {
                try {
                    return window.self === window.top;
                } catch {
                    return false;
                }
            })();

            // If it is available…
            if (supportsPicker && !isChromeOnIOS) {
                try {
                    const handle = await window.showSaveFilePicker({
                        suggestedName: filename,
                        types: [
                            {
                                description: 'PDF document',
                                accept: {'application/pdf': ['.pdf']},
                            },
                        ],
                    });
                    const writable = await handle.createWritable();
                    await writable.write(blob);
                    await writable.close();
                    this.log('Using the File System Access API', 'low');
                    return true; // ✔️ File downloaded
                } catch (err) {
                    if (err.name === 'AbortError') {
                        return false; // ✖️ User canceled the download
                    }
                    console.error("An error occured", err);
                    throw err;
                }
            } 

            if (!supportsPicker || isChromeOnIOS) {
                // ⚠️ Fallback to standard (download)
                const url = pdfUrl || URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = filename;
                document.body.append(link);
                link.click();
                link.remove();
                setTimeout(() => URL.revokeObjectURL(url), 1000);
                this.log('⚙️ Fallback to standard', 'low');
                return true;  // 🤷‍♂️ It is impossible to know if it worked
            }
        },


        createPrintPdfIframe(pdfFile, pdfUrl){
         let iframe = document.createElement('iframe');
         // Naming it, so it can be deleted later
         iframe.id = 'print_pdf'
         iframe.name = 'print_pdf'
         iframe.style.display = "none";
         iframe.src = pdfUrl;
         document.body.appendChild(iframe);
                       // as soon as it is loaded => print
         iframe.onload = () => {
            setTimeout(async ()=>{
                let success = false;

                try {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                    this.userPrintedHisCouponWithSuccess = true; 
                    success = true;

                } catch (error) {
                    success = await this.downloadCouponPdf(pdfFile, pdfUrl);
                }
                try {
                    this.log("Success: " + success, 'low');
                    // In any case, success or not, we go to confirmation page.
                    this.pendingParticipationSent = false;
                    this.currentPage = 'confirmationCoupon';
                }catch(error){
                    console.error(error);
                }
            }, 200);
        }
        iframe.onerror = event => {
            console.error("Error loading iframe:", event);
            this.userPrintedHisCouponWithSuccess = false;
            this.pendingParticipationSent = false;
        }
        this.$store.dispatch('setSpinner', false);
    },








    printableCouponIsReceived(data){
        this.log("Print coupon is received", 'green');
        this.printPdf(data.data);
    },

    printableCouponIsNotReceived(error){
        this.log("Print coupon is not received", 'red');
        this.iGotThisErrorFromActionApi(error, this.$t('errors.printCouponsNotWorking'));

            // reactive bouton for another try
        this.userPrintedHisCouponWithSuccess = false;

        this.pendingParticipationSent = false;
        this.$store.dispatch('setSpinner', false);
    },

},
}
